// Dependencies
import {
  TIPOS_UNIDAD_REQUEST,
  TIPOS_UNIDAD_OK,
  TIPOS_UNIDAD_ERROR,
} from "./types";

const initialState = {
  qty: null,
  data: [],
  loading: false,
  error: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TIPOS_UNIDAD_REQUEST:
      return { ...state, loading: true };
    case TIPOS_UNIDAD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case TIPOS_UNIDAD_OK:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        qty: action.payload.qty,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
